<template>
  <div class="rounded-lg alerts-list elevation-2">
    <v-list>
      <div class="fixed-header">
        <v-skeleton-loader type="list-item-two-line" width="20%" />

        <v-divider class="mb-4"></v-divider>
      </div>

      <div class="scrollable-alerts">
        <v-list-item v-for="n in 6" :key="n" class="mb-2 elevation-0">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header class="px-4">
                <v-row no-gutters align="center">
                  <v-col>
                    <v-skeleton-loader
                      type="list-item-two-line"
                      width="20%"
                      class="mb-2"
                    />
                  </v-col>
                  <v-col cols="auto">
                    <v-skeleton-loader type="chip" />
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-list-item>
      </div>
    </v-list>
  </div>
</template>

<script>
export default {
  name: "AlertsLoadingView",
};
</script>

<style scoped>
.v-list {
  background-color: var(--color-surface) !important;
  position: relative;
}

.alerts-list {
  max-height: calc(100vh - 9.2em);
  overflow: hidden;
  margin: 16px;
  width: calc(100% - 2em);
  border-radius: var(--radius-md);
  background-color: var(--color-surface);
}

.fixed-header {
  position: sticky;
  top: 0;
  background-color: var(--color-surface);
  z-index: 1;
}

.scrollable-alerts {
  overflow-y: auto;
  max-height: calc(100vh - 15em);
  padding-bottom: 1em;
}

.skeleton-item {
  width: 30%;
}

.loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.loading-text {
  margin-top: 16px;
  color: var(--color-text-muted);
}

/* Theme skeleton loaders */
.v-skeleton-loader__text >>> * {
  height: 12px !important;
  background-color: var(--color-border) !important;
  border-radius: var(--radius-sm) !important;
}

.v-skeleton-loader__list-item-two-line >>> * {
  background-color: transparent !important;
}

.v-skeleton-loader__list-item-avatar-two-line >>> * {
  background-color: transparent !important;
}

.v-skeleton-loader__chip >>> * {
  background-color: var(--color-border) !important;
  border-radius: var(--radius-md) !important;
}

.v-skeleton-loader__avatar >>> * {
  background-color: var(--color-border) !important;
}

.v-skeleton-loader__heading >>> * {
  background-color: var(--color-border) !important;
  border-radius: var(--radius-sm) !important;
}

.v-skeleton-loader__subtitle >>> * {
  background-color: var(--color-border) !important;
  opacity: 0.7;
  border-radius: var(--radius-sm) !important;
}

/* Skeleton loader animation */
.v-skeleton-loader >>> * {
  background-color: transparent !important;
}

.v-skeleton-loader__bone >>> * {
  background: linear-gradient(
    90deg,
    var(--color-border) 25%,
    var(--color-surface-light) 50%,
    var(--color-border) 75%
  ) !important;
  background-size: 200% 100% !important;
  animation: skeleton-loading 1.5s infinite !important;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.v-expansion-panels::v-deep .v-expansion-panel {
  background-color: var(--color-surface) !important;
  border: 1px solid var(--color-border) !important;
  border-radius: var(--radius-md) !important;
  margin-bottom: 8px;
}

.v-expansion-panels::v-deep .v-expansion-panel-header {
  background-color: var(--color-surface) !important;
  color: var(--color-text) !important;
  border-radius: var(--radius-md) !important;
  padding: 16px 20px;
}

.v-expansion-panels::v-deep .v-expansion-panel-header:hover {
  background-color: var(--color-surface-light) !important;
}

.v-expansion-panels::v-deep .v-expansion-panel-header--active {
  background-color: var(--color-surface-light) !important;
  border-bottom: 1px solid var(--color-border) !important;
}

.v-expansion-panels::v-deep .v-expansion-panel-content {
  background-color: var(--color-surface) !important;
  border-top: 1px solid var(--color-border) !important;
}

.v-expansion-panels::v-deep .v-expansion-panel-content__wrap {
  padding: 20px;
  color: var(--color-text) !important;
}

/* Theme list item titles and subtitles */
.v-list-item-title {
  color: var(--color-text) !important;
  font-weight: 500;
}

.v-list-item-subtitle {
  color: var(--color-text-muted) !important;
}

.v-expansion-panels::v-deep .v-expansion-panel-header__icon:hover {
  color: var(--color-secondary-light) !important;
}

.v-expansion-panels::v-deep .v-expansion-panel-header__icon .v-icon {
  color: var(--color-secondary) !important;
  transition: transform var(--transition-default) !important;
  transform: rotate(0deg) !important;
}

.v-expansion-panels::v-deep
  .v-expansion-panel-header--active
  .v-expansion-panel-header__icon {
  color: var(--color-secondary) !important;
  transform: rotate(-180deg) !important;
}

.v-expansion-panels::v-deep .v-expansion-panel-header {
  position: relative;
}

.v-expansion-panels::v-deep .v-expansion-panel-header__icon::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: transparent;
  transition: var(--transition-default);
  z-index: -1;
}

.v-expansion-panels::v-deep
  .v-expansion-panel-header:hover
  .v-expansion-panel-header__icon::before {
  background-color: var(--color-secondary-light);
  opacity: 0.1;
}

.v-expansion-panels::v-deep
  .v-expansion-panel-header--active
  .v-expansion-panel-header__icon::before {
  background-color: var(--color-secondary);
  opacity: 0.15;
}
</style> 